import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card, CardBody, Table, Button } from "reactstrap";
import { motion } from "framer-motion";
import Swal from "sweetalert2"; // Import SweetAlert2
import Section from "./Section";
import { AuthContext } from "../../../ExtraPages/AuthProvider";
import axios from "axios";
import { getAllCofRequests } from "../../../../api/BoatInspector/InspectorApi";

import {
  getCofRequestsOfficer,
  checkCof,
  updateCofRequestStatus,
} from "../../../../api/cof";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faRefresh,
  faRocket,
  faCreditCard,
  faSpaghettiMonsterFlying,
} from "@fortawesome/free-solid-svg-icons";
import "./status.css";

const BoatInspectorDashboard = () => {
  const [requests, setRequests] = useState([]);
  const [cofDetails, setCofDetails] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [confirmAction, setConfirmAction] = useState({
    show: false,
    id: null,
    status: "",
  });

  const statusClassMap = {
    Rejected: "status-button-danger",
    Pending: "status-button-warning",
    Accepted: "status-button-success",
  };

  const { user } = useContext(AuthContext);

  const [userId, setUserId] = useState(null);

  const fetchAllCofDetails = async (requests) => {
    try {
      const cofResponses = await Promise.all(
        requests.map(
          (req) => checkCof(`${req.tripId}`).catch(() => null) // Handle errors gracefully
        )
      );

      // Store COF details in an object with requestId as key
      const cofData = {};
      requests.forEach((req, index) => {
        if (cofResponses[index]?.data) {
          cofData[req.tripId] = cofResponses[index].data;
        }
      });
      console.log(cofData);
      setCofDetails(cofData);
    } catch (error) {
      console.error("Error fetching COF details:", error);
    }
  };

  // Re-fetch when the requestId changes
  // Always call useEffect, even if user is null
  useEffect(() => {
    // Ensure that the user is available before making the API call
    if (user && user.uid) {
      const fetchPendingCofs = async () => {
        try {
          //setLoading(true); // Start loading
          const response = await getCofRequestsOfficer(user.uid); // API call with user.uid
          setRequests(response.data); // Update state with fetched data
          fetchAllCofDetails(response.data);
        } catch (error) {
          console.error("Error fetching pending COFs:", error);
        } finally {
          //setLoading(false); // End loading
        }
      };

      fetchPendingCofs(); // Call the async function inside useEffect
    }
  }, [user]);

  const handleStatusChange = async (id, newStatus) => {
    try {
      const response = await updateCofRequestStatus(id, { status: newStatus });
      console.log(response.data);

      // Update the request status locally
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request._id === id ? { ...request, status: newStatus } : request
        )
      );

      Swal.fire({
        title: "Success!",
        text: `Request successfully ${newStatus.toLowerCase()}!`,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to update status.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const fillCof = (requestId, vesselNumber) => {
    //setRequestId(requestId);
    window.location.href = `/cof/${requestId}/${vesselNumber}`;
  };

  const confirmStatusChangeAccepted = (id, newStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to accept this request?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, confirm it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleStatusChange(id, newStatus);
      }
    });
  };

  const confirmStatusChangeRejected = (id, newStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to reject this request?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, confirm it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleStatusChange(id, newStatus);
      }
    });
  };

  const rowVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  // Define columns
  const columns = [
    {
      name: "Date",
      selector: (row) => row.requestDate,
      sortable: true,
    },
    {
      name: "Time Slot",
      selector: (row) => row.timeSlot,
      sortable: true,
    },
    {
      name: "Vessel Number",
      selector: (row) => row.vesselNumber,
    },
    {
      name: "Harbour",
      selector: (row) => row.harbour,
      sortable: true,
      right: false, // Aligns the content to the right
    },

    {
      name: "Status",
      selector: (row) => (
        <button className={`${statusClassMap[row.status]}`}>
          {row.status}
        </button>
      ),
      sortable: true,
      right: false, // Aligns the content to the right
    },
    {
      name: "Actions",
      selector: (row) => (
        <div>
          {row.status === "Pending" ? (
            <button
              color="success"
              size="sm"
              className="table-button table-button-success"
              onClick={() => confirmStatusChangeAccepted(row._id, "Accepted")}
            >
              Accept
            </button>
          ) : (
            ""
          )}
          {row.status === "Pending" ? (
            <button
              color="danger"
              size="sm"
              className="ms-2 table-button table-button-danger"
              onClick={() => confirmStatusChangeRejected(row._id, "Rejected")}
            >
              Reject
            </button>
          ) : (
            ""
          )}
          {row.status === "Accepted" &&
            cofDetails &&
            (!cofDetails[row.tripId] ? ( // Handles both undefined and null cases
              <Button
                color="primary"
                size="sm"
                onClick={() => fillCof(row.tripId, row.vesselNumber)}
                style={{ marginLeft: "10px" }}
              >
                COF
              </Button>
            ) : (
              <Button
                color="primary"
                size="sm"
                onClick={() => fillCof(row.tripId, row.vesselNumber)}
                style={{ marginLeft: "10px" }}
              >
                COF
              </Button>
            ))}
        </div>
      ),
      sortable: false,
      right: true, // Aligns the content to the right
    },
  ];

  return (
    <>
      {/* <Section /> */}
      <Container fluid style={{ marginTop: "40px" }}>
        <section className="section gaps bg-light">
          <Row
            className="g-4"
            style={{
              marginTop: "60px",
              background: "white",
              marginBottom: "20px",
              padding: "30px",
              borderRadius: "20px",
            }}
          >
            {(() => {
              // Compute real values from requests
              const today = new Date();
              const todayStr = today.toISOString().slice(0, 10);
              const thisMonth = today.getMonth();
              const thisYear = today.getFullYear();

              const totalOrders = requests.length;
              const todayOrders = requests.filter((r) => {
                if (!r.requestDate) return false;
                // Accept both ISO and yyyy-mm-dd
                return r.requestDate.slice(0, 10) === todayStr;
              }).length;
              const thisMonthOrders = requests.filter((r) => {
                if (!r.requestDate) return false;
                const d = new Date(r.requestDate);
                return (
                  d.getMonth() === thisMonth && d.getFullYear() === thisYear
                );
              }).length;
              const processingOrders = requests.filter(
                (r) => r.status !== 'Accepted' && r.status !== 'Rejected'
              ).length;

              const orderCards = [
                {
                  title: 'Total Orders',
                  value: totalOrders,
                  icon: faShoppingCart,
                  background: '#00A991',
                  className: 'border-right1',
                },
                {
                  title: 'Today',
                  value: todayOrders,
                  icon: faShoppingCart,
                  background: '#EFC059',
                  className: 'border-right1',
                },
                {
                  title: 'This month',
                  value: thisMonthOrders,
                  icon: faShoppingCart,
                  background: '#EA5C4C',
                  className: 'border-right1',
                },
                {
                  title: 'Processing',
                  value: processingOrders,
                  icon: faRefresh,
                  background: '#D3862A',
                  className: '',
                },
              ];
              return orderCards.map((card, index) => (
                <Col
                  sm={12}
                  lg={3}
                  md={12}
                  key={index}
                >
                  <div className={card.className}>
                    <div
                      className="m-b-20"
                      style={{ color: 'black' }}
                    >
                      <FontAwesomeIcon
                        icon={card.icon}
                        className="f-left"
                        style={{
                          fontSize: '1.2rem',
                          borderRadius: '40px',
                          padding: '10px',
                          background: card.background,
                          color: 'white',
                        }}
                      />
                      <div style={{ position: 'relative', left: '20px' }}>
                        <div className="text-black">{card.title}</div>
                        <div>
                          <h3>{card.value}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ));
            })()}
          </Row>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <h5 className="mb-4">Boat Inspection Requests</h5>
                  <div className="table-responsive">
                    <DataTable columns={columns} data={requests} />
                  </div>
                </CardBody>
              </Card>
              <br />
            </Col>
          </Row>
        </section>
      </Container>
    </>
  );
};

export default BoatInspectorDashboard;
